import { cva } from 'class-variance-authority';

export const bentoGrid = cva([
  'grid grid-cols-1 gap-l auto-cols-0',
  // We're not using a multi-column grid for now.
  // 'xl:grid-cols-3 xl:grid-flow-dense xl:[grid-auto-rows:calc((100cqw_-_2*var(--size-m))_/_3)]',
]);

export const bentoTile = cva('overflow-hidden', {
  variants: {
    size: {
      '1:1': {/**'xl:col-span-1 xl:row-span-1'**/},
      '2:1': {/**'xl:col-span-2 xl:row-span-1'**/},
      '1:2': {/**'xl:col-span-1 xl:row-span-2'**/},
      '2:2': {/**'xl:col-span-2 xl:row-span-2'**/},
    },
    background: {
      surface: 'rounded-m bg-surface border border-default',
      'surface-strong': 'rounded-m bg-surface-strong border border-default',
      'surface-strong-borderless': 'rounded-m bg-surface bg-surface-strong',
      'accent-subtle': 'rounded-m bg-accent-subtle border border-default',
      accent: 'rounded-m bg-accent border border-default',
      'positive-subtle': 'rounded-m bg-positive-subtle border border-default',
      transparent: 'p-xs',
      // Empty on purpose: the child owns the surface.
      none: '',
    },
    shadow: {
      true: 'shadow-s',
      false: '',
    },
  },
  defaultVariants: {
    size: '1:1',
    background: 'surface',
    shadow: true,
  },
});
